import { cn } from '@rocco/utils/cn';
import { REVAMP_BODY_PROSE, REVAMP_DROP_CAP } from '../../util/article-prose';

interface RevampRichTextProps {
    contentHTML?: string;
    className?: string;
    /**
     * Promote the column's authored `h3` to an `h2`. The page-builder only
     * offers editors an H3 title column, but a module title is the first
     * heading under the article's `h1`, so leaving it at h3 skips a level.
     * Set it on the title columns; body copy keeps its authored levels.
     */
    promoteHeading?: boolean;
    /**
     * Open the first paragraph on the drop cap — where the article starts
     * after the intro. Only the first body module asks for it.
     */
    leadIn?: boolean;
}

/** The h2 and h3 rules in this component are identical, so retagging is purely semantic. */
const promoteH3ToH2 = (html: string) => html.replace(/<(\/?)h3\b/gi, '<$1h2');

/**
 * Renders page-builder rich text (already CMS-sanitised, same source as the
 * legacy RichTextDisplay) with the revamp's editorial typography.
 */
export const RevampRichText = ({
    contentHTML,
    className,
    promoteHeading = false,
    leadIn = false,
}: RevampRichTextProps) => {
    if (!contentHTML) return null;

    // The paragraphs as the editor wrote them: every return is a paragraph,
    // and an empty one is an empty line.
    const html = promoteHeading ? promoteH3ToH2(contentHTML) : contentHTML;

    return (
        <div
            className={cn(
                REVAMP_BODY_PROSE,
                leadIn && REVAMP_DROP_CAP,
                className,
            )}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
